module.exports = __webpack_public_path__ + "images/navigation/juul-pods-27361fd2.png";